import React from 'react';

import { Typography } from '@material-ui/core';
import { ArrowLeft } from 'lucide-react';
import QRCode from 'react-qr-code';

import { theme } from '@waglabs/base-theme';
import { Box } from '@waglabs/box-next';
import { Grid } from '@waglabs/grid';

type Props = {
  deepLink: string;
  containerClassName?: string;
  ctaCopy?: string;
}

const defaultCtaCopy = 'Find the perfect Pet Caregiver for your furry friend';

export const ScanMe = ({
  deepLink,
  containerClassName = '',
  ctaCopy = defaultCtaCopy,
}: Props) => {
  const containerStyle = {
    justifyContent: 'center',
    display: 'flex',
    ...(containerClassName && { className: containerClassName }),
  };

  const qrCodeBoxStyle = {
    display: 'flex',
    border: '8px solid gainsboro',
    backgroundColor: 'white',
    width: '147px',
    height: '147px',
    borderRadius: '16px',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const infoContainerStyle = {
    backgroundColor: theme.colors.charcoal,
    alignSelf: 'center',
    borderTopRightRadius: '16px',
    borderBottomRightRadius: '16px',
    padding: '0.5rem',
    width: '250px',
    height: '100px',
    display: 'grid',
    justifyContent: 'center',
  };

  const textStyle = {
    fontSize: '1rem', // Adjust as needed
    color: 'white',
  };

  return (
    <Grid
      style={containerStyle}
    >
      <Box style={qrCodeBoxStyle}>
        <QRCode size={112} value={deepLink} />
      </Box>
      <Grid style={infoContainerStyle}>
        <Grid
          gridAutoFlow="column"
          gridTemplateColumns="repeat(9, 1fr)"
        >
          <ArrowLeft
            color="white"
            size={20}
            style={{
              gridColumn: '1/span 1',
              alignSelf: 'center',
            }}
          />
          <Typography
            style={{ ...textStyle,
              fontFamily: 'Muli Bold',
              gridColumn: '2/span 5' }}
          >
            SCAN ME

          </Typography>
        </Grid>
        <hr
          style={{
            marginTop: '4px',
            marginBottom: '4px',
            width: '226px',
            height: '1px',
          }}
          color={theme.colors.darkGray}
        />
        <Typography style={{
          ...textStyle,
          fontFamily: 'Muli',
        }}
        >
          {ctaCopy}

        </Typography>
      </Grid>
    </Grid>
  );
};
